
<template>
  <luma-empty>
    <luma-accounting-debit></luma-accounting-debit>
  </luma-empty>
</template>
<script>
    import {ApiRoutesModel} from "@/store/models/layout/api_routes";
    import LumaEmpty from "@/layout/LumaEmpty"
    import LumaAccountingDebit from "./debit_accounting/luma-accounting-debit";

    export default {
        name: "accounting-debit",
        components: {LumaAccountingDebit, LumaEmpty},
        created() {
            const debit = ApiRoutesModel.getResponseData('get.billing.debit',{})
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/accounting/accounting-debit.vue